export default __webpack_public_path__ + "static/media/icon-selectionnez un patient.149ab82c.svg";